// extracted by mini-css-extract-plugin
export default {"card":"startNow_card__BXfga","actions":"startNow_actions__tZYIE"};